import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import Navbar from './resources/navbar/navbar';
import LandingPage from './resources/landingpage/landingpage';
import Cursos from './resources/landingpage/cursos/cursos';
import Inscripcion from './resources/inscribete/inscripcion';
import InteresPage from './resources/landingpage/interesados/InteresPage';
import Login from './resources/login/LoginAdministrativos';
import Homepage from './resources/homepage/Homepage';
import Home from './resources/miplataforma/home/home';
import GenerarBoletin from './resources/miplataforma/boletin/generarboletin/generarboletin';
import ProtectedRoute from "./server/ProtectedRoute";

import reportWebVitals from './reportWebVitals';
import ToastContainer from './resources/toastify/ToastContainer';

function App() {
  const [openFormulario, setOpenFormulario] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const email = localStorage.getItem('userEmail');
    const role = localStorage.getItem('userRole');

    if (email && role) {
      setUserEmail(email);
      setUserRole(role);
      setIsAuthenticated(true);
    }

    setLoading(false);
  }, []);

  const handleLogin = (email, role) => {
    setUserEmail(email);
    setUserRole(role);
    setIsAuthenticated(true);

    localStorage.setItem('userEmail', email);
    localStorage.setItem('userRole', role);
  };

  const handleLogout = () => {
    setUserEmail(null);
    setUserRole(null);
    setIsAuthenticated(false);

    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
  };

  if (loading) return null;

  return (
    <>
      <Routes>

        {/* SOLO "/" */}
        <Route
          path="/"
          element={
            isAuthenticated
              ? <Navigate to="/administrativos" replace />
              : (
                <>
                  <Navbar onOpenFormulario={() => setOpenFormulario(true)} />
                  <LandingPage
                    openFormulario={openFormulario}
                    onSetOpenFormulario={setOpenFormulario}
                  />
                </>
              )
          }
        />

        {/* Públicas */}
        <Route
          path="/landingpage"
          element={
            <>
              <Navbar onOpenFormulario={() => setOpenFormulario(true)} />
              <LandingPage
                openFormulario={openFormulario}
                onSetOpenFormulario={setOpenFormulario}
              />
            </>
          }
        />

        <Route
          path="/tecnicoslaborales"
          element={
            <>
              <Navbar onOpenFormulario={() => setOpenFormulario(true)} />
              <Cursos
                openFormulario={openFormulario}
                onSetOpenFormulario={setOpenFormulario}
              />
            </>
          }
        />

        <Route path="/interes" element={<InteresPage />} />
        <Route path="/inscribete" element={<Inscripcion />} />

        {/* 🔥 LOGIN SIN REDIRECCIÓN AUTOMÁTICA */}
        <Route
          path="/login"
          element={<Login onLogin={handleLogin} />}
        />

        {/* Protegidas */}
        <Route
          path="/administrativos/:section?"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Homepage
                userEmail={userEmail}
                userRole={userRole}
                onLogout={handleLogout}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/miplataforma"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Home
                userEmail={userEmail}
                onLogout={handleLogout}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/boletin"
          element={<GenerarBoletin />}
        />

      </Routes>

      <ToastContainer />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();